import React from "react"
import PropTypes from "prop-types"
import "./UnitSkeleton.scss"

const UnitSkeleton = ({ shape = "rect", size = "medium", styleClass = "" }) => {
   const classNames = [
      "unit-skeleton",
      `unit-skeleton--${shape}`,
      `unit-skeleton--${size}`,
      styleClass,
   ].join(" ")

   return <div className={classNames}></div>
}

UnitSkeleton.propTypes = {
   shape: PropTypes.oneOf(["rect", "circle", "rounded"]),
   size: PropTypes.oneOf(["tiny", "xsmall", "small", "medium", "large"]),
   styleClass: PropTypes.string,
}

export default UnitSkeleton
